/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import SocialMedia from 'components/Components/Includes/SocialMedia';
import { Link } from 'react-router-dom';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import PropTypes from 'prop-types';
import { getImgAltText } from 'utils/alt-attribute-helper';

class Footer extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            showModalShare: false,
            showModalQuote: false,
            visible: 'hidden',
        };
        this.handleOpenModalShare = this.handleOpenModalShare.bind(this);
        this.handleCloseModalShare = this.handleCloseModalShare.bind(this);
        this.handleOpenModalQuote = this.handleOpenModalQuote.bind(this);
        this.listenScrollEvent = this.listenScrollEvent.bind(this);
    }

    handleOpenModalShare()
    {
        this.setState({ showModalShare: true });
    }

    handleCloseModalShare()
    {
        this.setState({ showModalShare: false });
    }

    handleOpenModalQuote()
    {
        this.setState({ showModalQuote: true });
    }

    listenScrollEvent()
    {
        if (window.scrollY > 200)
        {
            this.setState({ visible: 'block' });
        }
        else
        {
            this.setState({ visible: 'hidden' });
        }
    }

    componentDidMount()
    {
        window.addEventListener('scroll', this.listenScrollEvent);
    }

    componentWillUnmount()
    {
        window.removeEventListener('scroll', this.listenScrollEvent);
    }

    render()
    {
        return (
            <section className="tw-pt-10 lg:tw-pt-20 tw-pb-5 tw-px-4 tw-bg-gray-800">

                {/* Content */}
                <div className="xl:tw-container tw-text-center">
                    <Fade bottom>
                        <h4 className="tw-uppercase font-sp tw-mb-10">Affiliate Agency</h4>
                        <picture className="tw-mx-4">
                            <img loading="lazy" className="tw-h-16 tw-inline-block" src="/assets/affiliates/forest-travel.svg" alt={getImgAltText('Forest Travel Affiliate Agency')} />
                        </picture>
                        <picture className="tw-mx-4">
                            <img loading="lazy" className="tw-h-16 tw-inline-block" src="/assets/affiliates/virtuoso.svg" alt={getImgAltText('Virtuoso Member')} />
                        </picture>
                    </Fade>
                    <Fade bottom>
                        <div className="tw-flex tw-content-center tw-flex-wrap tw-mt-16 tw-text-left tw-mx-2 tw-border-gray-700 tw-border-b tw-pb-5">
                            <div className="tw-w-full md:tw-w-1/2 lg:tw-w-1/4 lg:tw-pr-2 tw-mb-10 lg:tw-mb-0">
                                <h4 className="tw-uppercase font-sp tw-mb-8">Contact</h4>
                                <span>Email:</span><a className="hover:tw-text-orange-400 tw-block tw-mb-1" href="mailto:info@luxuriavacations.com">info@luxuriavacations.com</a>
                                <p>Phone Number:</p><a className="hover:tw-text-orange-400 tw-block tw-mb-1" href="tel:18447858575">1 (844) 785-8575</a>
                                <p>Emergency Line (24/7):</p><a className="hover:tw-text-orange-400 tw-block tw-mb-1" href="tel:18447858575">1 (844) 785-8575 Ext.2</a>
                                <p className="tw-mt-5 lg:tw-mt-10">2420 NE Miami Gardens Dr #401</p>
                                <p>Miami, FL 33180</p>
                            </div>
                            <div className="tw-w-full md:tw-w-1/2 lg:tw-w-1/4 lg:tw-px-2 tw-mb-10 lg:tw-mb-0">
                                <h4 className="tw-uppercase font-sp tw-mb-8">Hours</h4>
                                <p className="tw-mb-1">Monday to Friday</p>
                                <p className="tw-mb-1">9:00 am - 7:00 pm</p>
                            </div>
                            <div className="tw-w-full lg:tw-w-1/2 lg:tw-pl-2">
                                <h4 className="tw-uppercase font-sp tw-mb-8 tw-text-gray-600">Useful Links</h4>
                                <div className="tw-flex tw-flex-wrap">
                                    <div className="tw-w-1/2">
                                        <Link to="/" className="hover:tw-text-orange-400 tw-block tw-mb-1">Home</Link>
                                        <Link to="/hotels" className="hover:tw-text-orange-400 tw-block tw-mb-1">Hotels</Link>
                                        <Link to="/destinations" className="hover:tw-text-orange-400 tw-block tw-mb-1">Destinations</Link>
                                        <a href="https://landing.luxuriavacations.com/about-us" className="hover:tw-text-orange-400 tw-block tw-mb-1"> About Us </a>
                                        <a href="https://blog.luxuriavacations.com/blog" target="_blank" className="hover:tw-text-orange-400 tw-block tw-mb-1"> Blog </a>
                                    </div>
                                    <div className="tw-w-1/2">
                                        <Link to="/faq" className="hover:tw-text-orange-400 tw-block tw-mb-1">FAQs</Link>
                                        <Link to="/contact-us" className="hover:tw-text-orange-400 tw-block tw-mb-1">Contact Us</Link>
                                        <Link to="/privacy-policy" className="hover:tw-text-orange-400 tw-block tw-mb-1">Privacy Policy</Link>
                                        <a href="https://app.termly.io/document/terms-of-use-for-website/ae402e0e-7649-4340-9124-24477145e7e6" target="_blank" className="hover:tw-text-orange-400 tw-block tw-mb-1">Terms of Service</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tw-flex tw-justify-center tw-flex-wrap tw-mx-2 tw-pt-5">
                            <div className="tw-w-full tw-mb-3">
                                <SocialMedia />
                            </div>
                            <div className="tw-w-full">
                                <p className="">All rights reserved. Copyright © {new Date().getFullYear()}. Luxuria Vacations</p>
                            </div>
                        </div>
                    </Fade>
                </div>

                {/* Top Anchor */}
                <AnchorLink href="#top">
                    <div className={`btn btn-gray tw-w-auto fixed top-anchor tw-text-center tw-uppercase font-sp tw-py-3 tw-px-4 tw-mx-auto tw-bg-gray-400 tw-text-gray-700 tw-w-auto ${this.state.visible}`}>
                        <span className="material-icons tw-align-middle">expand_less</span>
                    </div>
                </AnchorLink>
            </section>
        );
    }
}

Footer.propTypes = {
    image: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    description: PropTypes.string,
    rooms: PropTypes.number,
    goingTo: PropTypes.string,
    id: PropTypes.number,
    type: PropTypes.string,
};

export default Footer;
